import $ from 'jquery'
import 'select2/dist/css/select2.css'

function initializeSelect2(elementSelector) {
    $(elementSelector).select2({tags: false, width: '100%', height: "auto"})
}

function listenSelected(elementSelector) {
    $(elementSelector).on('select2:select', function (e) {
    });
}

export { initializeSelect2, listenSelected }